<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        2019年大连海大智龙科技有限公司获得13项软件著作权授权
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
           <div class="div-text-left news-Regular-14b6">
            <span>2020-01-06</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news1.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news2.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news3.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news4.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news5.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news6.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news7.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news8.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news9.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news10.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news11.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news12.jpg" />
          </div>
        </div>
      </div>
      <div class="div-row">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news4/news13.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }

 

  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  img {
    vertical-align: middle;
    border-style: none;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news4.vue